import { ref } from "vue"

const isLoading = ref(false)

export const useLoading = ()=>{

    const switchLoading = (isShow:boolean)=>{
        isLoading.value = isShow
    }
    return {isLoading, switchLoading}
}